import { Injectable, Inject, isDevMode } from '@angular/core';
import { SpAttachmentConfig, SpAttachmentConfigService } from '../config';
import { Observable, of } from 'rxjs';
// Third party imports
import { sp, AttachmentFileInfo } from '@pnp/sp';

@Injectable({
    providedIn: 'root'
})
export class SpAttachmentLibraryService {

    constructor(@Inject(SpAttachmentConfigService) private config: SpAttachmentConfig) {
        // setup sp
        sp.setup({
            sp: {
                headers: {
                    'Accept': 'application/json;odata=verbose',
                },
                baseUrl: this.config.baseUrl,
            }
        });
    }

    getAttachmentsById(listName: string, itemId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            const item = sp.web
                .lists
                .getByTitle(listName)
                .items
                .getById(itemId);

            item.attachmentFiles
                .get()
                .then((response) => {
                    resolve({ result: response });
                })
                .catch((e) => {
                    reject({ result: false, message: e.message });
                });

        });
    }

    addAttachment(listName: string, itemId: number, attachment: AttachmentFileInfo): Promise<any> {
        return new Promise((resolve, reject) => {
            const item = sp.web
                .lists
                .getByTitle(listName)
                .items.getById(itemId);

            item.attachmentFiles.add(attachment.name, attachment.content).then(response => {
                resolve({ result: response });
            }).catch((e) => {
                reject({ result: false, message: e.message });
            });
        });
    }

    addAttachments(listName: string, itemId: number, attachments: AttachmentFileInfo[]): Promise<any> {
        return new Promise((resolve, reject) => {
            const item = sp.web
                .lists
                .getByTitle(listName)
                .items.getById(itemId);

            item.attachmentFiles.addMultiple(attachments).then(response => {
                resolve({ result: response });
            }).catch((e) => {
                reject({ result: false, message: e.message });
            });
        });
    }

    deleteAttachment(listName: string, itemId: number, fileName: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const item = sp.web
                .lists
                .getByTitle(listName)
                .items.getById(itemId);

            item.attachmentFiles.getByName(fileName).delete().then(response => {
                resolve({ result: response });
            }).catch((e) => {
                reject({ result: false, message: e.message });
            });
        });
    }

    deleteAttachments(listName: string, itemId: number, fileNames: string[]): Promise<any> {
        return new Promise((resolve, reject) => {
            const item = sp.web
                .lists
                .getByTitle(listName)
                .items.getById(itemId);
            item.attachmentFiles.deleteMultiple(...fileNames).then(response => {
                resolve({ result: response });
            }).catch((e) => {
                reject({ result: false, message: e.message });
            });
        });
    }

    getAttachmentContent(listName: string, itemId: number, fileName: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const item = sp.web
                .lists
                .getByTitle(listName)
                .items.getById(itemId);

            item.attachmentFiles.getByName(fileName).getBlob().then(response => {
                resolve({ result: response });
            }).catch((e) => {
                reject({ result: false, message: e.message });
            });
        });
    }

    updateAttachmentContent(listName: string, itemId: number, fileName: string, content: string | Blob | ArrayBuffer): Promise<any> {
        return new Promise((resolve, reject) => {
            const item = sp.web
                .lists
                .getByTitle(listName)
                .items.getById(itemId);

            item.attachmentFiles.getByName(fileName).setContent(content).then(response => {
                resolve({ result: response });
            }).catch((e) => {
                reject({ result: false, message: e.message });
            });
        });
    }

}
